import React, { useState, useEffect } from "react";
import { Col, Row, Modal, ModalBody, Input, Label, Form } from "reactstrap";
import { Container} from "reactstrap";
import { Link } from "react-router-dom";
import { AppConfiguration } from "read-appsettings-json";
import { GetRequest, PostRequest } from '../../../noser-dataaccess'
import axios from 'axios'

//Job Images
import jobImage1 from "../../../assets/images/featured-job/img-01.png";
import jobImage2 from "../../../assets/images/featured-job/img-02.png";
import jobImage3 from "../../../assets/images/featured-job/img-03.png";
import jobImage4 from "../../../assets/images/featured-job/img-04.png";
import { useNavigate } from "react-router-dom";
import { Typeahead } from 'react-bootstrap-typeahead';
import "react-bootstrap-typeahead/css/Typeahead.css";

const JobVacancy = () => {
  // Navigate to another screen 
  const navigate = useNavigate();
  const navigateApp = useNavigate();
  const navigateEmployer = useNavigate();

  //Apply Now Model
  const [modal, setModal] = useState(false);
  const openModal = () => setModal(!modal);
  const [jobVacancy, setJobVacancy] = useState([]);
  const [storeJson, setStoreJson] = useState([]);
  const [compProfile, setJson] = useState([]);
  
  const [jobVacancyDDL, setJobVacancyDDL] = useState([]);
  const [compNameDDL, setCompNameDDL] = useState([]);
  const [jobTypeDDL, setJobTypeDDL] = useState([]);
  const [jobDept, setJobDeptDDL] = useState([]);
  const [validate, setValidate] = useState("");
  const [isHide, setOnhide] = useState(false);
  
  const [srchCompName, setCompName] = useState("");
  const [srchLocation, setLocation] = useState("");
  const [srchJobClass, setJobClass] = useState("");
  const [srchPosition, setPosition] = useState("");

  
  useEffect(() => {

    const isValidate = JSON.parse(sessionStorage.getItem("userCollection"))
    if (isValidate === null){

      setValidate("0")
      
    }
    else {

      if(isValidate[0].isEmployer === "1"){

        setValidate("1")

      }
      else {

        setValidate("0")

      }
    }
    GetCompanyProfile()

  }, []);

  const GetCompanyProfile = async() => {

    let filter_data = {"isDeleted": "0"}
    const dataTmp = []

    // // console.log("1")
    const Params = {

      // "dbname"      :  AppConfiguration.Setting().noserJobSpaceDB_Prod,
      "_collection" : "CompanyProfile",
      "filter_data" : filter_data

    }
    // // console.log("2")
    axios
    .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
    .then(res => {

      // // console.log("3")
      let data = res.data

      // // // console.log("data company prof")
      // // // console.log(data.CompanyProfile)

      data.CompanyProfile.map(function(itm,i){

        const strJson = itm.replace("","").replace("ObjectId(","").replace(")","").replace("_","")
        const json = JSON.parse(strJson.replace(/'/g,'"'));
        dataTmp.push(json)
        // // // console.log("json")
        // // // console.log(json) 

      })   

      // console.log("dataTmp")
      // console.log(dataTmp)  

      setJson(dataTmp)  
      GetDataJobposting(dataTmp); 

    })
  };


  const GetDataJobposting =async(_dataList)=> {

    let dataListTmp = []

    try{

      let resp = await GetRequest({
        
        url : AppConfiguration.Setting().jobspaceapi + "action/get",
        params : {

          "dbname"      :  AppConfiguration.Setting().noserJobSpaceDB_Prod,
          "_collection" : "JobPosting",
          "filter_data" : {}

        }

      })


        console.log("resp.JobPosting")
        console.log(resp.JobPosting)

      if(resp.status==="1"){

        // setCompanyId(companyProfList[0].id)
        resp.JobPosting.forEach((itm,idx)=> {

          // console.log("itm")
          // console.log(itm)

          // // // // console.log("_dataList.filter(x=> x.userId===itm.companyId)")
          // // // // console.log(_dataList.filter(x=> x.userId===itm.companyId))

          let expTmp = itm.experienceMin + " " + "-" + " " + itm.experienceMax

          // let locCity =   _dataList.filter(x=> x.userId===itm.companyId).length>0 ?
          //                 _dataList.find(x=> x.userId===itm.companyId).locationCity: ""
          // let locPrvnce = _dataList.filter(x=> x.userId===itm.companyId).length>0 ?
          //                 _dataList.find(x=> x.userId===itm.companyId).locationProvince: ""

          let sal1 = String(itm.salaryMin).replaceAll(',','')
          let sal2 = String(itm.salaryMax).replaceAll(',','')

          let _salaryRangeTmp = toTitleCase(itm.salaryCurrency) + " " + parseFloat(sal1).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + " " + "-" + " " + toTitleCase(itm.salaryCurrency)  + " " + parseFloat(sal2).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
          
          let _location = _dataList.filter(x=> x.userId===itm.companyId).length>0 ?
                          _dataList.find(x=> x.userId===itm.companyId).city: ""

          let noCapsLabelLoc = (_location).toLowerCase()
          let LocTmp = toTitleCase(noCapsLabelLoc)
          
          // let tmCompname = _dataList.filter(x=> x.userId===itm.companyId).length>0 ?
          //                   _dataList.find(x=> x.userId===itm.companyId).companyName: ""
          // let noCapsLabel = (tmCompname).toLowerCase()
          // let compName = toTitleCase(noCapsLabel)

          dataListTmp.push({

            companyName : itm.companyName,
            location : _location,
            companyId : itm.companyId,
            createdBy : itm.createdBy,
            createdDate : itm.createdDate,
            description : itm.Urgency,
            endDate : itm.endDate,
            experienceMax : itm.experienceMax,
            experienceMin : itm.experienceMin,
            id : itm.id,
            isClosed : itm.isClosed,
            isDeleted : itm.isDeleted,
            isPosted : itm.isPosted,
            keyWords : itm.keyWords,
            level : itm.level,
            postingId : itm.postingId,
            qualifications : itm.qualifications,
            responsibility : itm.responsibility,
            salaryBasis : itm.salaryBasis,
            salaryCurrency : itm.salaryCurrency,
            salaryMax : itm.salaryMax,
            salaryMin : itm.salaryMin,
            skillsExperience : itm.skillsExperience,
            startDate : itm.startDate,
            timeStamp : itm.timeStamp,
            title : itm.title,
            workType : itm.workType,
            urgency : itm.Urgency,
            updatedBy : itm.updatedBy,
            industry : itm.industry,
            updatedDate : itm.updatedDate,
            exp : expTmp,
            salaryRange : _salaryRangeTmp,
            notes : itm.jobPostingNote,
            workLocation : itm.workLocation,
            jobDepartment : itm.jobDepartment,

          })

        })

      }

      // console.log(dataListTmp)

      setJobVacancy(dataListTmp.sort((a, b) => a.id < b.id ? 1 : -1))
      setStoreJson(dataListTmp.sort((a, b) => a.id < b.id ? 1 : -1))

      let locDistnct = dataListTmp.filter((thing, index, self) =>
        index === self.findIndex((t) => (
          t.workLocation === thing.workLocation
      )))
      setJobVacancyDDL(locDistnct.sort((a, b) => a.id < b.id ? 1 : -1))

      let compNameDistnct = dataListTmp.filter((thing, index, self) =>
        index === self.findIndex((t) => (
          t.companyName === thing.companyName
      )))
      setCompNameDDL(compNameDistnct.sort((a, b) => a.id < b.id ? 1 : -1))

      let jobTypeDistnct = dataListTmp.filter((thing, index, self) =>
        index === self.findIndex((t) => (
          t.industry === thing.industry
      )))
      setJobTypeDDL(jobTypeDistnct.sort((a, b) => a.id < b.id ? 1 : -1))

      let jobDept = dataListTmp.filter((thing, index, self) =>
        index === self.findIndex((t) => (
          t.title === thing.title
      )))
      setJobDeptDDL(jobDept.sort((a, b) => a.id < b.id ? 1 : -1))


    }
    catch(error){
      
      // setMessage(error.message)
      alert("error: " + error.message)

    }
  };

  function toTitleCase(str) {

    const titleCase = str
      .toLowerCase()
      .split(' ')
      .map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  
    return titleCase;

  }

  function handleNavigate(key) {

    // alert("test")
    // // // console.log("validate")
    // // // console.log(validate)

    if(validate==="1"){

      // // console.log("if")
      sessionStorage.setItem("key", JSON.stringify(key.postingId))
      navigateEmployer("/JobDescEmployer");

    }
    else {

      // // console.log("else")
      sessionStorage.setItem("key", JSON.stringify(key.postingId))
      navigate("/JobDetailsDescription");

    }

  };

  function handleNavigateApplication(itms) {

    sessionStorage.setItem("key", JSON.stringify(itms.postingId))
    sessionStorage.setItem("companyId", JSON.stringify(itms.companyId))
    navigateApp("/ApplicationPage");
      
    // GetCompanyProfile()
  };

  const onChangeCompName = (e, value) =>{

    if(e.length === 0){
      setCompName("")
    }
    else{
      setCompName(e[0].companyName)
    }
    

  }

  const onChangeLocation = (e, value) =>{

    if(e.length === 0){
      setLocation("")
    }
    else{
      setLocation(e[0].workLocation)
    }
    

  }

  const onChangeJobClass = (e, value) =>{

    if(e.length === 0){
      setJobClass("")
    }
    else{
      setJobClass(e[0].industry)
    }
    

  }

  const onChangePosition = (e, value) =>{

    if(e.length === 0){
      setPosition("")
    }
    else{
      setPosition(e[0].title)
    }
    

  }

  

  function toTitleCase(str) {
    const titleCase = str
      .toLowerCase()
      .split(' ')
      .map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  
    return titleCase;
  }

  // Search Function 


  

  const handleSearchFilter = async() => {

    // setisLoading(true)

    let _fdata = helperBuildCriteria()
    let _filterData = _fdata.split(",")
    let _objfd = {}

    let jsonData = {};
    for (let i = 0; i < _filterData.length - 1; i++) {

      let columnName = _filterData[i].split(":")[0]
      _objfd[columnName] = _filterData[i].split(":")[1];

    }
    ////////////// // console.log("filter_data")
    ////////////// // console.log(_objfd)

    GetFilterResult(_objfd);
  }

  

  const helperBuildCriteria = () => {

    let _filterData = {}
    let compname = ""
    let loc = ""
    let title = ""
    let pos = ""

    // console.log("srchCompName")
    // console.log(srchCompName)
// 
    if ( srchCompName != "" || srchCompName!== "" ) {

      compname = "companyName" + ":" + srchCompName + ","

    }

    if ( srchLocation != "" || srchLocation!== "" ) {

      loc = "workLocation" + ":" + srchLocation + ","

    }

    if ( srchJobClass != "" || srchJobClass!== "" ) {

      title = "industry" + ":" + srchJobClass + ","

    }

    if ( srchPosition != "" || srchPosition!== "" ) {

      pos = "title" + ":" + srchPosition + ","

    }

    _filterData = /* "isDeleted" + ":" + "0," + */ compname + loc + title + pos //+ _podate + _costcenter + _receiptdescription + _ponumber + _company
   
    return _filterData
    
  }

  const GetFilterResult = async(_objfd) => {

    // console.log("_objfd")
    // console.log(_objfd)


    try{

      let tempArr = []
    
      let resp = await GetRequest({

        url : AppConfiguration.Setting().jobspaceapi + "action/get",
        params : {

          "dbname"      :  AppConfiguration.Setting().noserJobSpaceDB_Prod,
          "_collection" : "JobPosting",
          "filter_data" : _objfd

        }

      })

      // console.log("resp")
      // console.log(resp)

      if(resp.status==="1"){
        
        let dataX = []

        resp.JobPosting.forEach((itm,idx)=> {
          // compProfile
          let expTmp = itm.experienceMin + " " + "-" + " " + itm.experienceMax
          
          let _salaryRangeTmp = toTitleCase(itm.salaryCurrency) + " " + itm.salaryMin + " " + "-" + " " + toTitleCase(itm.salaryCurrency)  + " " + itm.salaryMax
          
          let _location = compProfile.filter(x=> x.userId===itm.companyId).length>0 ?
                          compProfile.find(x=> x.userId===itm.companyId).city: ""
          
          let noCapsLabelLoc = (_location).toLowerCase()
          
          let LocTmp = toTitleCase(noCapsLabelLoc)
          
          let tmCompname = compProfile.filter(x=> x.userId===itm.companyId).length>0 ?
                            compProfile.find(x=> x.userId===itm.companyId).companyName: ""
          
          let noCapsLabel = (tmCompname).toLowerCase()

          let compName = toTitleCase(noCapsLabel)


          dataX.push({

            companyName : itm.companyName,
            location : LocTmp,
            companyId : itm.companyId,
            createdBy : itm.createdBy,
            createdDate : itm.createdDate,
            description : itm.Urgency,
            endDate : itm.endDate,
            experienceMax : itm.experienceMax,
            experienceMin : itm.experienceMin,
            id : itm.id,
            isClosed : itm.isClosed,
            isDeleted : itm.isDeleted,
            isPosted : itm.isPosted,
            keyWords : itm.keyWords,
            level : itm.level,
            postingId : itm.postingId,
            qualifications : itm.qualifications,
            responsibility : itm.responsibility,
            salaryBasis : itm.salaryBasis,
            salaryCurrency : itm.salaryCurrency,
            salaryMax : itm.salaryMax,
            salaryMin : itm.salaryMin,
            skillsExperience : itm.skillsExperience,
            startDate : itm.startDate,
            timeStamp : itm.timeStamp,
            title : itm.title,
            workType : itm.workType,
            urgency : itm.Urgency,
            industry : itm.industry,
            updatedBy : itm.updatedBy,
            updatedDate : itm.updatedDate,
            exp : expTmp,
            salaryRange : _salaryRangeTmp,
            notes : itm.jobPostingNote,
            workLocation : itm.workLocation,

          })

        })

        // // console.log(dataX)

        setJobVacancy(dataX.sort((a, b) => a.id < b.id ? 1 : -1))

      }

    }
    catch(error){
      // setMessage(error.message)
      // console.log("error: " + error.message)
    }

  }

  const onClickClear = (e) =>{

    alert("qwet")
  }

  return (
    <React.Fragment>
      
      <section className="bg-home" id="home" style={{marginLeft: "5%", marginRight: "5%", marginTop: "-8.5%"}}>
        
        <div className="lg-overlay"></div>

        {/* <Container style={{ marginTop: "-8.5%"}}> */}

          {isHide === false ? 

            <Row className="justify-content-center">
              <Col lg={12}>
                <div className="text-center" style={{color:"#088B1E"}}>
                  <h1 className="fw-semibold mb-3"style={{fontSize: "25px"}}>
                    Search Between More Than{" "}
                    <span className="text-warning fw-bold" style={{color:"#A6AB14", fontSize: "25px"}}>10,000+ </span>
                    Available Jobs.
                  </h1>
                  <p style={{fontSize: "18px"}}>
                    Find jobs, create traceable resumes and enrich your applications.
                  </p>
                </div>
              </Col>
            </Row>
          : 
          null
          }

          <Form action="#"style={{marginTop: "1%", width: "100%"}}>
            <div className="registration-form">
              <Row className="g-0">
                <Col lg={3}>
                  <div className="filter-search-form filter-border mt-3 mt-lg-0">
                    {/* <i className="mdi mdi-search-web" style={{ color: "grey"}}></i> */}
                    
                    {/* <Input
                      type="search"
                      id="job-title"
                      className="form-control filter-input-box"
                      placeholder="Job, Company Name"
                      style={{backgroundColor: "#e7e7e7", color: "#000000"}}
                      onChange={onChangeCompName}
                    /> */}
                      
                      
                    {/* <select
                      name="companyName"
                      className="form-control filter-input-box"
                      style={{width : "300px", backgroundColor: "#e7e7e7"}}
                      // value={row.itemCode}
                      // disabled = {row.taxType === "" ? true : false}
                      onChange={(e) => onChangeCompName(e, e.target.value)} 
                      >
                      <option>Select Company Name</option>
                        {compNameDDL.filter(x=> x.companyName !== "").map((itm, idx) => (
                          <option key={idx} value={itm.companyName}>{itm.companyName}</option>
                        ))
                      }
                    </select> */}

                    

                    
                    <Typeahead
                      clearButton // = { (e) => onClickClear(e)}
                      labelKey="companyName"
                      id="selections-example"
                      onChange={(e) => onChangeCompName(e)}
                      options={compNameDDL}
                      style={{height: "60px"}}
                      // selected={[getDocumentStatusValue]}
                      //options={getDataSelection.filter(x => x.labelId === containsWhitespace(item.fieldName) === true ? removeWhitespace(item.fieldName).toLowerCase() : item.fieldName.toLowerCase() )}
                      placeholder={"Select Company"}
                    />
                    

                  </div>
                </Col>
                <Col lg={2}>
                  <div className="filter-search-form filter-border mt-3 mt-lg-0" style={{marginLeft: "-5%"}}>
                    <Typeahead
                      clearButton
                      labelKey="workLocation"
                      id="selections-example"
                      onChange={(e) => onChangeLocation(e)}
                      options={jobVacancyDDL}
                      style={{height: "60px"}}
                      // selected={[getDocumentStatusValue]}
                      //options={getDataSelection.filter(x => x.labelId === containsWhitespace(item.fieldName) === true ? removeWhitespace(item.fieldName).toLowerCase() : item.fieldName.toLowerCase() )}
                      placeholder={"Select Location"}
                    />
                  </div>
                </Col>
                <Col lg={2}>
                  <div className="filter-search-form filter-border mt-3 mt-lg-0" style={{marginLeft: "-5%"}}>
                    {/* <i className="uil uil-clipboard-notes" style={{ color: "grey"}}></i> */}
                    
                    {/* <Input
                      type="search"
                      id="job-title"
                      className="form-control filter-input-box"
                      placeholder="Job Type, Classification"
                      style={{backgroundColor: "#e7e7e7", color: "#000000"}}
                      onChange={onChangeJobClass}
                    /> */}

                    {/* <select
                      name="industry"
                      className="form-control filter-input-box"
                      style={{width : "300px", backgroundColor: "#e7e7e7"}}
                      // value={row.itemCode}
                      // disabled = {row.taxType === "" ? true : false}
                      onChange={(e) => onChangeJobClass(e, e.target.value)} 
                      >
                      <option >Select Classification</option>
                        {jobTypeDDL.filter(x=> x.industry !== "").map((itm, idx) => (
                          <option style={{fontWeight: "bold"}} key={idx} value={itm.industry}>{itm.industry}</option>
                        ))
                      }
                    </select> */}

                  
                  
                    <Typeahead
                      clearButton
                      labelKey="industry"
                      id="selections-example"
                      onChange={(e) => onChangeJobClass(e)}
                      options={jobTypeDDL}
                      style={{height: "60px"}}
                      // selected={[getDocumentStatusValue]}
                      //options={getDataSelection.filter(x => x.labelId === containsWhitespace(item.fieldName) === true ? removeWhitespace(item.fieldName).toLowerCase() : item.fieldName.toLowerCase() )}
                      placeholder={"Select Classification"}
                    />

                    {/* <select
                      className="form-control" 
                      id="nameControlInput" 
                      placeholder="Employment Type" 
                      style={{ borderStyle: "outset"}}
                      onChange={ e => handleChangeEmploymentType(e)}
                    >
                      {empJobType.map((resp) => (
                        <option key={resp.id} value={resp.department}>
                          {resp.department}
                        </option>
                      ))}
                    </select> */}
                  </div>
                </Col>
                <Col lg={2}>
                  <div className="filter-search-form filter-border mt-3 mt-lg-0" style={{marginLeft: "-5%"}}>
                    {/* <i className="uil uil-map-marker" style={{ color: "grey"}}></i> */}
                      <Typeahead
                        clearButton
                        labelKey="title"
                        id="selections-example"
                        onChange={(e) => onChangePosition(e)}
                        options={jobDept}
                        style={{height: "60px"}}
                        // selected={[getDocumentStatusValue]}
                        //options={getDataSelection.filter(x => x.labelId === containsWhitespace(item.fieldName) === true ? removeWhitespace(item.fieldName).toLowerCase() : item.fieldName.toLowerCase() )}
                        placeholder={"Select Position"}
                      />
                  </div>
                </Col>
                <Col lg={3}>
                  <div className="mt-3 mt-lg-0 h-100">
                    <button
                      className="btn btn-success submit-btn w-100 h-100"
                      type="submit"
                      onClick={handleSearchFilter}
                    >
                      <i className="uil uil-search me-1"></i>
                      Find Jobs
                    </button>
                  </div>
                </Col>
              </Row>
            </div>
          </Form>

          <Row>
            <Col lg={12}>
              <ul className="treding-keywords list-inline mb-0 text-white-50 mt-4 mt-lg-3 text-center">
                <li className="list-inline-item text-white" style={{color:"#088B1E"}}>
                  {/* <i className="mdi mdi-tag-multiple-outline text-warning fs-18"></i>{" "} */}
                  <label style={{color:"#088B1E", fontSize: "14px"}}>Trending Keywords:</label>
                </li>
                <li className="list-inline-item">
                  <Link to="#"> <label style={{color:"#088B1E", fontSize: "14px"}}>Design,</label></Link>
                </li>
                <li className="list-inline-item">
                  <Link to="#"> <label style={{color:"#088B1E", fontSize: "14px"}}>Development,</label></Link>
                </li>
                <li className="list-inline-item">
                  <Link to="#"> <label style={{color:"#088B1E", fontSize: "14px"}}>Manager,</label></Link>
                </li>
                <li className="list-inline-item">
                  <Link to="#"> <label style={{color:"#088B1E", fontSize: "14px"}}>Senior</label></Link>
                </li>
              </ul>
            </Col>
          </Row>
          {/* <div className={isHide === true ? 'display-block' : 'display-none'}> */}
            {jobVacancy.map((jobVacancyDetails, key) => (
              <div
                key={key}
                className={
                  jobVacancyDetails.addclassNameBookmark === true
                    ? "job-box bookmark-post card mt-4"
                    : "job-box bookmark-post card mt-4"
                }
                style={{backgroundColor : "#F0FEED", marginBottom: "-1.2%", borderColor: "green", border: "0.5px solid green"}}
              >
                <div className="p-4" onClick={e => handleNavigate(jobVacancyDetails)}>
                  <Row >
                    <Col lg={1}>
                      <Link /* onClick={e => handleNavigate(jobVacancyDetails)} */>
                        <img
                          src={jobVacancyDetails.companyImg}
                          alt=""
                          className="img-fluid rounded-3"
                        />
                      </Link>
                    </Col>
                    <Col lg={3}>
                      <div className="mt-3 mt-lg-0">
                        <Label className="mb-1" style={{fontSize: "18px"}}>
                          <Link /* onClick={e => handleNavigate(jobVacancyDetails)} */ /* to="/jobdetails" */ className="text-dark" >
                            <b>{jobVacancyDetails.title}</b>
                          </Link>{" "}
                        </Label>
                        <ul className="list-inline mb-0">
                          <li className="list-inline-item">
                            <p className="mb-0" style={{fontSize: "16px", color: "#000000"}}>
                              {jobVacancyDetails.companyName}
                            </p>
                          </li>
                        </ul>
                      </div>
                    </Col>
                    
                    <Col lg={2}>
                      <div className="mt-3 mt-lg-0">
                        <li className="list-inline-item">
                          <p className="mb-0" style={{fontSize: "14px", color: "#000000"}}>
                            <i className="mdi mdi-map-marker"></i>{" "}
                            {jobVacancyDetails.workLocation}
                          </p>
                        </li>
                      </div>
                    </Col>

                    <Col lg={3}>
                      <div className="mt-3 mt-lg-0">
                        <li className="list-inline-item">
                          <p className="mb-0" style={{fontSize: "14px", color: "#000000"}}>
                            <i className="uil uil-wallet"></i>{" "}
                            {jobVacancyDetails.salaryRange}
                          </p>
                        </li>
                      </div> 
                    </Col>
                    <Col lg={3}>
                    {jobVacancyDetails.workType === "" ? 
                      null
                    :
                      <button type="submit" className="btn btn-success noser-button-md" 
                        style={{minWidth : "40%", 
                        textAlign : "center", 
                        borderRadius : 5, 
                        // color : "whitesmoke", 
                        // backgroundColor : "green", 
                        borderWidth : "0px", 
                        marginLeft : "5%",
                        fontSize: "14px",
                        padding : "8px"}}
                      >
                        {jobVacancyDetails.workType}
                      </button>
                    }
                    {jobVacancyDetails.urgency === "" ? 
                      null
                    :
                      <button type="submit" className="btn btn-success noser-button-md" 
                        style={{minWidth : "40%", 
                        textAlign : "center", 
                        fontSize: "14px",
                        borderRadius : 5, 
                        color : "whitesmoke", 
                        backgroundColor : "green", 
                        borderWidth : "0px", 
                        marginLeft : "15%",
                        padding : "8px"}}
                      >
                        {jobVacancyDetails.urgency}
                      </button>
                    }
                    </Col>
                  </Row>
                </div>
                <div className="p-3" style={{ backgroundColor : "#E0FDDB"}}>
                  <Row className="justify-content-between">
                      <Col lg={1}>
                        <ul className="list-inline mb-0">
                          <li className="list-inline-item" style={{ color: "#000000"}}>
                            Experience:
                          </li>
                        </ul>
                        </Col>
                        <Col lg={4} >
                        {jobVacancyDetails.notes === "" ? 
                          null
                        : 
                          <Link to="#" /* className="text-muted" */ style={{fontSize: "14px", color: "#000000", textAlign: "justify", marginLeft: "1%"}}>
                            {jobVacancyDetails.exp}
                          </Link>
                        }
                        </Col>
                        
                        <Col lg={4}>
                        <ul className="list-inline mb-0">
                          <li className="list-inline-item">
                            {jobVacancyDetails.notes === "" ? 
                              null
                            :
                              <Link to="#" /* className="text-muted" */ style={{fontSize: "14px", color: "#000000"}}>
                                Notes: &nbsp;{jobVacancyDetails.notes}
                              </Link>
                            }
                          </li>
                        </ul>
                      </Col>

                    <Col sm={2}>
                      {validate==="1" ? 
                        null
                        :
                        <div className="text-md-end" onClick={(e)=> handleNavigateApplication(jobVacancyDetails)}>
                          <Link
                            // to="/ApplicationPage"
                            className="primary-link"
                            style={{fontSize: "14px", color: "#000000"}}
                          >
                            <b style={{ color: "green"}}>Apply Now</b><i className="mdi mdi-chevron-double-right" style={{ color: "green"}}></i>
                          </Link>
                        </div>
                      }
                    </Col>
                  </Row>
                </div>
              </div>
            ))}
          {/* </div> */}

          <div
            className="modal fade"
            id="applyNow"
            tabIndex="-1"
            aria-labelledby="applyNow"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <Modal isOpen={modal} toggle={openModal} centered>
                <ModalBody className="modal-body p-5">
                  <div className="text-center mb-4">
                    <h5 className="modal-title" id="staticBackdropLabel">
                      Apply For This Job
                    </h5>
                  </div>
                  <div className="position-absolute end-0 top-0 p-3">
                    <button
                      type="button"
                      onClick={openModal}
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="mb-3">
                    <Label for="nameControlInput" className="form-label">
                      Name
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="nameControlInput"
                      placeholder="Enter your name"
                    />
                  </div>
                  <div className="mb-3">
                    <Label for="emailControlInput2" className="form-label">
                      Email Address
                    </Label>
                    <Input
                      type="email"
                      className="form-control"
                      id="emailControlInput2"
                      placeholder="Enter your email"
                    />
                  </div>
                  <div className="mb-3">
                    <Label for="messageControlTextarea" className="form-label">
                      Message
                    </Label>
                    <textarea
                      className="form-control"
                      id="messageControlTextarea"
                      rows="4"
                      placeholder="Enter your message"
                    ></textarea>
                  </div>
                  <div className="mb-4">
                    <Label className="form-label" for="inputGroupFile01">
                      Resume Upload
                    </Label>
                    <Input
                      type="file"
                      className="form-control"
                      id="inputGroupFile01"
                    />
                  </div>
                  <button type="submit" className="btn btn-success w-100">
                    Send Application
                  </button>
                </ModalBody>
              </Modal>
            </div>
          </div>

        {/* </Container> */}

      </section>

    </React.Fragment>
  );
};

export default JobVacancy;